import pageLoadingAnimation from "../../images/animations/LoadingPage.gif";

interface Props {}
export function LongLoadingAnimation(props: Props) {
	return (
		<img
			className="long-loading-animation"
			src={pageLoadingAnimation}
			alt="Loading animation"
		></img>
	);
}
